package pt.at.oss.kotlin.manual.validator.importform

import pt.at.oss.kotlin.manual.schema.importform.ImportFormSchema
import pt.at.oss.kotlin.manual.storage.importform.ImportForm
import pt.at.oss.kotlin.manual.validator.common.AddressValidator
import pt.at.oss.kotlin.manual.validator.common.BankAccountInfoValidator
import pt.at.oss.kotlin.manual.validator.common.ContactInfoValidator
import pt.at.oss.kotlin.manual.validator.common.ContactNameValidator
import pt.at.oss.kotlin.manual.validator.common.CountryOfBusinessValidator
import pt.at.oss.kotlin.manual.validator.common.FixedEstablishmentsValidator
import pt.at.oss.kotlin.manual.validator.common.FixedEstablishmentsValidator.Type.ESTABLISHMENT
import pt.at.oss.kotlin.manual.validator.common.FreeTextValidator
import pt.at.oss.kotlin.manual.validator.common.IDENTIFICATION_OF_BUSINESS_VAT_ID_VALIDATOR
import pt.at.oss.kotlin.manual.validator.common.IdentOfBusinessValidator
import pt.at.oss.kotlin.manual.validator.common.PREV_OR_CURR_OSS_VAT_IDS_VALIDATOR
import pt.at.oss.kotlin.manual.validator.common.TradingNamesValidator
import pt.at.oss.kotlin.manual.validator.common.WebsitesValidator
import pt.lightweightform.kotlin.type.validator.ValidationError
import pt.lightweightform.kotlin.type.validator.ValidationErrors

class ImportFormValidator {

    fun validate(model: ImportForm, isByIntermediary: Boolean): ValidationErrors {
        val schemaErrors = ImportFormSchema().validate(model)

        if (schemaErrors.errors.isNotEmpty()) {
            return schemaErrors
        } else {
            val extraErrors = mutableListOf<ValidationError>()

            // companyName
            // ->required and has max size
            FreeTextValidator.validateFreeText(model.companyName)
                ?.also { extraErrors.add(it) }

            // nationalTaxNumber
            // ->required and has max size

            // tradingNames
            TradingNamesValidator.tradingNamesValidate(model.tradingNames.size, model.companyName)
                ?.also { extraErrors.add(it) }
            extraErrors.addAll(model.tradingNames.mapNotNull { FreeTextValidator.validateFreeText(it.name) })

            // countryOfBusiness
            extraErrors.addAll(CountryOfBusinessValidator().validateSequencial(model.countryOfBusiness, model.cobRegion, isByIntermediary, true))

            // identificationOfBusiness
            extraErrors.addAll(IDENTIFICATION_OF_BUSINESS_VAT_ID_VALIDATOR.validateVatIdSequencial(model.identificationOfBusiness))

            // business+issuingCountry
            IdentOfBusinessValidator.validateEqualCountryAndIssuer(model.countryOfBusiness, model.cobRegion, model.identificationOfBusiness.issuingCountry, true)
                ?.also { extraErrors.add(it) }

            IdentOfBusinessValidator.validateIssuerNotXiXu(model.identificationOfBusiness.issuingCountry, model.identificationOfBusiness.vatIdNum)
                ?.also { extraErrors.add(it) }

            // RFC-960 - Algumas regiões obrigam a que o cobRegion seja igual ao issuingCountry
            IdentOfBusinessValidator.validateNatTaxRefMandatoryIssuer(model.cobRegion, model.identificationOfBusiness.issuingCountry)
                ?.also { extraErrors.add(it) }

            // address
            extraErrors.addAll(AddressValidator().validateAddressSequencial(model.address))

            // websites
            // ->when present required and has max size
            // ->formatted correctly
            extraErrors.addAll(WebsitesValidator.validateWebsitesSequential(model.websites, true))

            // contactName
            extraErrors.addAll(ContactNameValidator.contactNameSequencialValidate(model.contactName))

            // contactInfo
            extraErrors.addAll(ContactInfoValidator.contactInfoSequencialValidate(model.contactInfo))

            // bankAccountInfo
            extraErrors.addAll(BankAccountInfoValidator.bankAccountInfoSequencialValidate(model.bankAccountInfo, false, !isByIntermediary))

            // fixedEstablishments
            extraErrors.addAll(FixedEstablishmentsValidator().validateFixedEstablishmentsSequencial(model.fixedEstablishments, listOf(ESTABLISHMENT)))

            // prevOrCurrOssVatId isoA2 and vat
            model.prevOrCurrOssVatId.forEach { prevOrCurrOssVatId ->
                extraErrors.addAll(PREV_OR_CURR_OSS_VAT_IDS_VALIDATOR.validateVatIdSequencial(prevOrCurrOssVatId))
            }

            return ValidationErrors(extraErrors)
        }
    }
}
